import fetcher from 'features/shared/utils/fetcher'
import { diagnostico } from '../types/diagnosticosType'

async function getDiagnosticos(searchValue = "CONVA") {
  return await fetcher.get<{ data: diagnostico[] }>(`/diagnosticos?descripcion=${searchValue}`)
}

export default getDiagnosticos
